export const surveyTaskForm = {
    mainInfo: {
        title: {
            mandatory: true,
            value: '',
        },
        department: {
            mandatory: true,
            value: null,
        },
        recipient: {
            mandatory: true,
            value: null,
        },
        info: {
            value: null,
        },
        attachmentList: {
            value: [],
        },
        confirmRead: {
            value: false,
            hide: true,
        },
        messagingEnabled: {
            value: false,
        },
        commentReaction: {
            value: null,
        },
        username: {
            mandatory: true,
            value: null,
        },
        storeId: {
            value: '',
        },
    },
    pointsAssignment: {
        badge: {
            value: null,
            mandatory: true,
        },
        points: {
            value: null,
            mandatory: true,
        },
    },
    scheduling: {
        startDate: {
            value: null,
            mandatory: true,
        },
        endDate: {
            value: null,
            mandatory: true,
        },
        projectVisibility: {
            value: null,
            mandatory: true,
        },
        daysBefore: {
            value: null,
        },
        specificDate: {
            value: null,
        },
        priority: {
            value: null,
            mandatory: true,
        },
        autoClose: {
            value: false,
        },
        autoCloseDays: {
            value: null,
        },
        calendarVisibility: {
            value: true,
        },
    },
}
